import { render, staticRenderFns } from "./DecisionTable.vue?vue&type=template&id=83df0f92&"
import script from "./DecisionTable.vue?vue&type=script&lang=js&"
export * from "./DecisionTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports